import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import moment from "moment";
import ProcessWorkPermitSelectPopup from '../../workPermit/ProcessWorkPermitSelectPopup.vue';

const root = {}
export default root
root.name = 'processWorkPermitDL';
root.props = {
	initUserData: Object,
	areaData: Object,
	operaDataCache: Object,
	workerSelect: Array,
	applicantSelect: Array,
	departmentSelect: Array
}
root.components = {
	ProcessWorkPermitSelectPopup
}
root.data = {
	workPermitDLData: {
		isShowProcessWorkPermitSelectPopup: false,
		preWorkInfo: [],
		headerDataCache: {
			//作业证编号
			no: '',
			//作业证名称
			name: new Date().getTime(),
			//计划开始时间
			planStartTime: '',
			//计划结束时间
			planEndTime: '',
			//区域id
			locationId: 0,
			departmentId:0,
			//作业地点
			place: '',
			protectionProduct: '',
			acceptanceEmpId: Number(localStorage.getItem("empId")), // 完工验收人id
			acceptanceOpinion: '',	//完收验工意见
			reviewEmpId: Number(localStorage.getItem("empId")), // 复核人id
			reviewOpinion: '',	//复核人意见
			jobExecutorEmpId: 0,//TODO 作业人id
			applyUserId: Number(localStorage.getItem("empId")), // 申请人id
			applyTime: moment().format('YYYY-MM-DD HH:mm:ss'),//申请作业时间
			contractorId: null, // 申请单位id
			certificateTypeId: 11,//作业票分类
		},

		//操作的缓存数据
		operaDataCache: {
			workUnit: '',//作业单位
			rui: '',//涉及相关单位
			reason: '',	//断路原因
			//危险辨识
			hi: '',
			//安全措施
			sms: [],
			//涉及的其他特殊作业
			ow: '',
			//涉及的其他特殊作业安全作业证编号
			owno: '',
			//相关说明
			description: '',
			signId: Number(localStorage.getItem("empId")),//签字人id
			signTime: moment().format('YYYY-MM-DD HH:mm:ss'),//签字时间
			//安全交底人
			aqjdrId: 0,
			//接受交底人
			jsjdrId: 0,
			companyCharger: 0,//作业单位负责人
			companyChargerComment: '',//作业单位负责人意见
			branchCharger: 0,//车间(分厂)负责人
			branchChargerComment: '',//车间(分厂)负责人意见
			approveCharger: 0,//审批部门(安全/消防部门)负责人
			approveChargerComment: '',//审批部门(安全/消防部门)负责人意见
			deptCharger: 0,
			deptChargerComment: ''
		},
	},
	// 上传附件
	fileList: [],
}

root.methods = {
	//格式化选择的涉及的其他特殊作业及编号
	formatPreWorkInfo: function () {
		let data = []
		console.log('this.workPermitDLData.preWorkInfo', this.workPermitDLData.preWorkInfo)
		for (var i = 0; i < this.workPermitDLData.preWorkInfo.length; i++) {
			let element = this.workPermitDLData.preWorkInfo[i]
			data.push(`${element.name}(${element.no})`)
		}

		data = data.join(',')
		return data
	},
	//获取选择的涉及的其他特殊作业及编号
	getWorkPermitData: function (e) {
		this.workPermitDLData.preWorkInfo = []
		console.log(e)
		e.forEach(element => {
			element.selectData.forEach(item => {
				this.workPermitDLData.preWorkInfo.push({ 'no': item.no, 'name': item.name })
			});
		});
		this.$store.commit('setPreWorkInfo', this.workPermitDLData.preWorkInfo)
		console.log('33333', this.workPermitDLData.preWorkInfo)
		this.workPermitDLData.isShowProcessWorkPermitSelectPopup = false

	},
	toOpenWorkCodePopup: function () {
		this.workPermitDLData.isShowProcessWorkPermitSelectPopup = true
	},
	returnCacheData: function () {
		return { ...this.workPermitDLData.headerDataCache, openCircuitPropsDto: this.workPermitDLData.operaDataCache };
	},

	// 解析业务字段，编辑时按新增页默认字段补齐
	fillPermitData: function (data, preserveWhenMissing) {
		data = data || {};
		this.workPermitDLData.headerDataCache = { ...this.workPermitDLData.headerDataCache, ...data };
		let businessData = {};
		if (data.businessJson) {
			if (typeof data.businessJson === 'object') {
				businessData = data.businessJson;
			} else {
				try {
					businessData = JSON.parse(data.businessJson);
				} catch (e) {
					businessData = {};
				}
			}
		}
		this.workPermitDLData.operaDataCache = { ...this.workPermitDLData.operaDataCache, ...businessData };
		if (!Array.isArray(this.workPermitDLData.operaDataCache.sms) || !this.workPermitDLData.operaDataCache.sms.length) {
			this.workPermitDLData.operaDataCache.sms = [];
			this.getPermitTypeData();
		}
		this.backfillPreWorkInfo(data, preserveWhenMissing);
	},
	// 回填涉及的其他特殊作业及编号
	backfillPreWorkInfo: function (data, preserveWhenMissing) {
		const hasPreWorkInfo = data && Object.prototype.hasOwnProperty.call(data, 'preWorkInfo');
		if (!hasPreWorkInfo && preserveWhenMissing) {
			this.$store.commit('setPreWorkInfo', this.workPermitDLData.preWorkInfo);
			return;
		}
		let preWorkInfo = hasPreWorkInfo ? data.preWorkInfo : [];
		if (typeof preWorkInfo === 'string') {
			try {
				preWorkInfo = preWorkInfo ? JSON.parse(preWorkInfo) : [];
			} catch (e) {
				preWorkInfo = [];
			}
		}
		if (!Array.isArray(preWorkInfo)) {
			preWorkInfo = [];
		}
		this.workPermitDLData.preWorkInfo = preWorkInfo;
		this.$store.commit('setPreWorkInfo', preWorkInfo);
	},

	//数据回填
	dataBackfill: function (data) {
		this.fillPermitData(data, true);
	},

	//获取作业证中的sms
	getPermitTypeData: function () {
		const self = this;
		self.componentsMoudel.startPost('/safetyMeasures/list_all', { permitType: 8 }, true).then(res => {
			self.workPermitDLData.operaDataCache.sms = res.body.data;
		});
	},
	// 上传的事件
	handleChange(file, fileList) {
		this.fileList = fileList
	},
	handleExceed(file, fileList) {
		this.$message.warning('限制上传一个文件')
	},
}

root.mounted = function () {

	if (this.operaDataCache.businessJson) {
		this.fillPermitData(this.operaDataCache);
	} else {
		this.workPermitDLData.operaDataCache.sms = [];
		this.backfillPreWorkInfo(this.operaDataCache);
		this.getPermitTypeData();
	}
}

FactoryComponents.initComponent(root);
